import { Autocomplete, TextField } from "@mui/material";
import { useCallback } from "react";
import SelectBox from "../../../components/common/SelectBox";
import { FormSection } from "./FormComponents";

/**
 * TaskTargetConfig component
 * Handles company selection and scraper image configuration
 */
const TaskTargetConfig = ({ selectedTaskData, setSelectedTaskData, companyNames, scraperVersionNames }) => {
  const handleCompanyChange = useCallback(
    (_, value) => setSelectedTaskData((prev) => ({ ...prev, selectedCompanies: value })),
    [setSelectedTaskData]
  );

  const handleScraperImageChange = useCallback(
    (value) => setSelectedTaskData((prev) => ({ ...prev, scraperImage: value })),
    [setSelectedTaskData]
  );

  return (
    <>
      <FormSection title="Company">
        <Autocomplete
          options={companyNames}
          multiple
          value={selectedTaskData.selectedCompanies}
          onChange={handleCompanyChange}
          renderInput={(params) => <TextField {...params} label="Select Company" />}
        />
      </FormSection>

      <FormSection title="Scraper Image">
        <SelectBox
          dataVals={scraperVersionNames}
          currentVal={selectedTaskData.scraperImage}
          handleVal={handleScraperImageChange}
          label={"Select Scraper Image"}
          disabled={!scraperVersionNames.length}
        />
      </FormSection>
    </>
  );
};

export default TaskTargetConfig;
